const DEFAULT_SIZE_TWO_DRAWERS = ['싱글', '슈퍼싱글'];
const NO_DRAWER = 'no drawer';
const TWO_DRAWERs = '2 drawers';
const FOUR_DRAWERS = '4 drawers';
const TWO_DRAWERS_LIMIT_WIDTH = 110;

class BlockVariant extends HTMLElement {
    constructor() {
        super();
        this.variantData = [];
        this.state = {
            variant: {},
            options: [],
        }
    }

    initState() {
        this.variantData = this.getVariantData();

        const defaultVariant = JSON.parse(this.getAttribute(':defaultVariant'));

        this.state = {
            ...this.state,
            variant: { ...defaultVariant },
            options: [...defaultVariant.options],
        }
    }

    connectedCallback() {
        this.initState();
    }

    updateState(state) {
        this.state = {
            ...this.state,
            ...state
        }

        this.updatePrice();
        this.updateDeliveryTime();
        this.updateCrossSellVariant();
        this.updateHistoryState();
        this.updateFeaturedImage();
        this.updateVariantId();
        this.updateAddToCartStatus();
        this.updateDrawers();
    }

    getCurrentVariant(newVariant) {
        const currentVariant = this.variantData.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(newVariant);
        });

        return currentVariant;
    }

    getVariantData() {
        return JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    updatePrice() {
        const { variant } = this.state;
        document.querySelector('block-price').handleMainProductVariantChange(variant);
    }

    handleVariantChanged(position, value) {
        const options = this.state.options;
        options[position] = value;

        if (position === 0 && !!options[2] && options[2] !== NO_DRAWER) {
            const width = document.querySelector('block-variant-drawers').getWidthOfSize(value);

            let drawers = TWO_DRAWERs;

            if (width > TWO_DRAWERS_LIMIT_WIDTH) {
                drawers = FOUR_DRAWERS;
            }

            options[2] = drawers;
        }

        this.onUpdateVariant(options);
    }

    onUpdateVariant(options) {
        const variant = this.getCurrentVariant(options);

        this.updateState({ variant, options });
    }

    updateDeliveryTime() {
        const { variant } = this.state;
        document.querySelector("block-delivery-time").updateDeliveryTime(variant);
    }

    updateHistoryState() {
        const { variant } = this.state;
        if (!history.replaceState) {
            return;
        }

        const newURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`
        window.history.replaceState({ path: newURL }, "", newURL);
    }

    updateCrossSellVariant() {
        const { variant } = this.state;
        document
            .querySelectorAll("block-cross-sell")
            .forEach((item) => item.handleMainProductVariantChange(variant));
    }

    updateFeaturedImage() {
        const src = this.state.variant?.featured_image?.src;

        if (!src) return;

        document.querySelector('block-product-image').updateImage(src);
        document.querySelector('#product-images-gallery #product-images-gallery-slide01 > img').setAttribute('srcset', src);
    }

    updateVariantId() {
        const variantIdElement = document.querySelector('form [name="id"]');
        variantIdElement.value = this.state.variant.id;
    }

    updateAddToCartStatus() {
        const { variant } = this.state;
        const { available } = variant;

        document.querySelector('block-add-to-cart-button').updateButtonState(available);
        document.querySelector('block-sticky-add-to-cart').updateButtonState(variant);
    }

    updateDrawers() {
        const { variant } = this.state;
        const { options } = variant;

        document.querySelector('block-variant-drawers')?.render(options[0], options[2]);
    }
}

customElements.define('block-variant', BlockVariant);